<template>
  <svg :width="size" :height="size" viewBox="0 0 20 20" fill="currentColor">
    <path d="M5.5 16a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 16h-8z"/>
  </svg>
</template>

<script>
export default {
  name: "IconCloud",
  props: {
    size: { type: [Number, String], default: 20 },
  },
};
</script>
